/**
 * Notification Subscription
 *
 * Browser Supabase realtime is disabled because auth is server-side and cookies
 * are HttpOnly. Notifications are refreshed through authenticated APIs.
 */

export interface NotificationSubscriptionCallbacks {
  onNewNotification?: (notification: any) => void;
  onRefreshNotifications?: () => void;
}

export interface NotificationSubscriptionConfig {
  userId: string;
  callbacks: NotificationSubscriptionCallbacks;
  enabled?: boolean;
}

export class NotificationSubscription {
  constructor(_config: NotificationSubscriptionConfig) {
    void _config;
  }

  subscribe(): void {
    // Server-side auth intentionally disables browser Supabase realtime.
  }

  cleanup(): void {
    // No browser channel to clean up.
  }
}
